import React from "react";
import {IconButton} from "@material-ui/core";
import LinkIcon from "@material-ui/icons/Link";
import FilterIcon from "@material-ui/icons/FilterList";
import ListLink from "common_components/flowmaster/llm_run/styled/ListLink";

interface StackedInfoProps {
  label: string;
  value: string;
  url?: string;
  filter?: () => void;
}

export default function StackedInfo({
  label,
  value,
  url,
  filter,
}: StackedInfoProps) {
  return (
    <div style={{marginBottom: "10px", width: "100%"}}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            textAlign: "left",
            flex: 1,
            minWidth: 0,
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: "0.75em",
              marginBottom: "2px",
            }}
          >
            {label}
          </div>

          <div
            style={{
              fontSize: "0.95em",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {value}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginLeft: "8px",
            flexShrink: 0,
          }}
        >
          {filter && (
            <IconButton size="small" onClick={filter} style={{padding: 2}}>
              <FilterIcon fontSize="small" />
            </IconButton>
          )}
          {url && (
            <ListLink to={url}>
              <IconButton size="small" style={{padding: 2}}>
                <LinkIcon fontSize="small" />
              </IconButton>
            </ListLink>
          )}
        </div>
      </div>
    </div>
  );
}
